<template>
  <div class="main">
    <div class="main-left">
      <div class="img-top">
        <img :src="rewardsChildData.imgurl" alt="图片" />
        <div>{{ rewardsChildData.name }}</div>
      </div>
      <div class="boxs-bottom">
        <div class="boxs" v-for="item in boxsList" :key="item">
          <span class="dollar">$</span>
          <span class="number">{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="main-right">
      <div class="title">{{ rewardsChildData.title }}</div>
      <p v-for="(item, index) in rewardsChildData.pList" :key="index">
        {{ item }}
      </p>
      <div class="explain">{{ rewardsChildData.explain }}</div>
      <div class="get-rewards">Get Rewards</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["rewardsChildData"],
  data() {
    return {
      boxsList: [5, 10, 15, 20, 25],
    };
  },
  created() {
    console.log(this.rewardsChildData);
  },
};
</script>
<style scoped>
.main {
  display: flex;
  margin-top: 10px;
}
.main-left {
  width: 173.125px;
}
.main-right {
  width: calc(100% - 30px);
  padding-left: 30px;
}
.img-top > img {
  width: 100%;
}
.img-top > div {
  font-size: 15.625px;
  margin-top: 12.5px;
  font-weight: bold;
  text-align: center;
}
.boxs-bottom {
  display: flex;
  flex-direction: column;
  margin-top: 21.875px;
}
.boxs {
  width: calc(100% - 23.125px);
  height: 37.5px;
  background: #f7f8fa;
  border-radius: 2.5px;
  border: 0.625px solid #dddddd;
  margin-bottom: 2.5px;
  padding-left: 21.875px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.boxs .dollar {
  font-size: 12.5px;
}
.boxs .number {
  margin-left: 5px;
  font-size: 16px;
}
.main-right .title {
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 18px;
}
.main-right p {
  width: 412.5px;
  font-size: 8.75px;
  margin-bottom: 23px;
  line-height: 15px;
}
.explain {
  width: 412.5px;
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 18px;
}
.get-rewards {
  width: 101.875px;
  height: 22.5px;
  background: #2e67ea;
  border-radius: 2.5;
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  line-height: 22.5px;
  cursor: pointer;
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/rewardsChild.vue